type SliderPropsT = {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  onChangeEnd?: (value: number) => void;
  className?: string;
  steps?: number;
};

function Slider({min, max, value, onChange, onChangeEnd, className, steps = 1}: SliderPropsT) {
  return (
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      step={steps}
      onChange={e => onChange(Number(e.target.value))}
      onMouseUp={e => onChangeEnd?.(Number(e.currentTarget.value))}
      onTouchEnd={e => onChangeEnd?.(Number(e.currentTarget.value))}
      className={`h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-200 dark:bg-gray-700 ${className}`}
    />
  );
}

export default Slider;
